export const AGGREGATE_ETA_DATA_COLUMNS = [
    {
      Header: "ACTUAL PICK UP DATE FROM FACTORY",
      accessor: "Actual_Pickup_date_from_factory",
      width : 1
    },
    {
      Header: "SAP SALES ORDER NO",
      accessor: "SAP_Sales_Order_No",
      width : 1
    },
    {
      Header: "PY/VY INVOICE NO",
      accessor: "PY_VY_Invoice_No",
      width : 1
    },
    {
      Header: "INTERNAL REFERENCE NO",
      accessor: "Internal_Reference_No",
      width : 1
    },
    {
      Header: "CONTAINER NO",
      accessor: "Container_No",
      width : 1
    },
    {
      Header: "DEST COUNTRY",
      accessor: "Dest_Country",
      width : 1
    },
    {
      Header: "DESTINATION PORT",
      accessor: "Destination_Port",
      width : 1
    },
    {
        Header: "AGGREGATE/CHASSIS",
        accessor: "Aggregate_Chassis",
        width : 1
      },
    {
      Header: "CARRIER",
      accessor: "Carrier",
      width : 1
    },
     {
      Header: "ENGINE NO",
      accessor: "Engine_No",
      width : 1
    },
   
 
   
  ];